<template>
  <v-footer padless app absolute inset class="app-footer">
    <div class="footer-wrap">
      <v-row class="ma-0">
        <!-- Brand -->
        <v-col cols="12" md="3" class="px-0 pr-md-6">
          <div class="brand" @click="onClickMenu('/')">
            <img src="../../assets/logo.png" alt="Dmeets" class="brand-logo" />
            <span class="brand-name">meets</span>
          </div>
          <p class="brand-desc">
            {{ checklanguage == 'th' ? 'การประชุมออนไลน์สำหรับทุกคน' : 'Professional video conferencing for all businesses' }}
          </p>
        </v-col>

        <!-- Product -->
        <v-col cols="6" sm="4" md="3" class="px-0">
          <h3 class="footer-heading">{{ checklanguage == 'th' ? 'ผลิตภัณฑ์' : 'Product' }}</h3>
          <a class="footer-link" @click="onClickMenu('/feature')">{{ lg_header_menu.feature || 'Features' }}</a>
          <!-- <a class="footer-link" @click="onClickMenu('/pricing')">{{ lg_header_menu.pricing || 'Pricing' }}</a> -->
        </v-col>

        <!-- Company -->
        <v-col cols="6" sm="4" md="3" class="px-0">
          <h3 class="footer-heading">{{ checklanguage == 'th' ? 'บริษัท' : 'Company' }}</h3>
          <a class="footer-link" @click="onClickMenu('/about')">{{ lg_header_menu.about }}</a>
          <a class="footer-link" @click="onClickMenu('/contact')">{{ lg_header_menu.contact }}</a>
        </v-col>

        <!-- Security -->
        <v-col cols="12" sm="4" md="3" class="px-0">
          <h3 class="footer-heading">{{ checklanguage == 'th' ? 'ความปลอดภัย' : 'Security' }}</h3>
          <a class="footer-link" @click="showInformationSecurityPolicy_2">{{ lg_footer.information_security_policy }}</a>
          <a class="footer-link" @click="showPrivacyPolicy_1">{{ lg_footer.privacy_policy }}</a>
          <a class="footer-link" @click="showDmeetsdocx_4">{{ lg_footer.terms_and_conditions }}</a>
          <a class="footer-link" @click="showDmeetsdocx_5">{{ lg_footer.recording_consent_policy }}</a>
        </v-col>
      </v-row>

      <div class="footer-bottom">
        <template v-if="checklanguage == 'th'">
          © สงวนลิขสิทธิ์ {{ year }} บริษัท ดิจิทัล คอร์ปอเรท เมเนจเม้นท์ จำกัด
          <span class="sep">|</span> พัฒนาในประเทศไทย
        </template>
        <template v-else>
          © {{ year }} Dmeets by Digital Corporate Management Co., Ltd. All rights reserved.
          <span class="sep">|</span> Developed in Thailand
        </template>
      </div>
    </div>
  </v-footer>
</template>

<script>
import api from "../../services/api";
import { server, feature } from "../../services/constants";
import { lg_footer } from "../../views/language/lg_footer.js";
import { lg_header_menu } from "../../views/language/lg_header_menu.js";

export default {
  name: "Footer",
  data() {
    return {
      title: "Footer",
      version: "1.0",
      acc_plan: "FREE",
      date_exire: "",
      checklanguage: "",
      checklogin: false,
      year: new Date().getFullYear(),
    };
  },
  async beforeCreate() {
    this.$store.state.page_reload = false;
    const isTh = localStorage.getItem(feature.LANGUAGE) === "th";
    this.lg_footer = isTh ? lg_footer.lg_footer_th : lg_footer.lg_footer_en;
    this.lg_header_menu = isTh ? lg_header_menu.lg_header_menu_th : lg_header_menu.lg_header_menu_en;
  },
  async mounted() {
    this.checklanguage = localStorage.getItem(feature.LANGUAGE);
    this.checklogin = api.isLoggedIn();
  },
  methods: {
    onClickMenu(link) {
      this.$router.push(link).catch(() => {});
    },
    showPrivacyPolicy_1() {
      window.open(`${window.location.origin}/privacy-policy`);
    },
    showInformationSecurityPolicy_2() {
      const file = this.checklanguage == "th"
        ? "Information_Security_Policy_(TH).pdf"
        : "Information_Security_Policy_(ENG).pdf";
      window.open(`${window.location.origin}/${file}`);
    },
    showTermandConditions_3() {
      window.open(`${window.location.origin}/3.TermandConditions.pdf`);
    },
    showDmeetsdocx_4() {
      const file = this.checklanguage == "th"
        ? "DCM_Terms_and_Conditions_(TH).pdf"
        : "DCM_Terms_and_conditions_(ENG).pdf";
      window.open(`${window.location.origin}/${file}`);
    },
    showDmeetsdocx_5() {
      const file = this.checklanguage == "th"
        ? "Recording_and_Consent_Policy_(TH).pdf"
        : "Recording_and_Consent_Policy_(ENG).pdf";
      window.open(`${window.location.origin}/${file}`);
    },
    getVersion() {
      this.version = localStorage.getItem(server.ACC_PLAN_STA) == "FREE"
        ? server.VERSION_FREE
        : server.VERSION_PREMIUM;
    },
  },
};
</script>

<!-- global rule เดิม (มีผลกับทั้งเว็บ) -->
<style>
@media only screen and (max-width: 600px) {
  .v-btn:not(.v-btn--round).v-size--default {
    height: 20px;
  }
}
</style>

<style scoped>
.app-footer {
  background: #f8fafc !important;
  border-top: 1px solid #e5e7eb;
  display: block;
}
.footer-wrap {
  max-width: 1216px;
  margin: 0 auto;
  padding: 48px 24px 0;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.brand-logo {
  width: 38px;
  height: 38px;
  object-fit: contain;
}
.brand-name {
  font-size: 24px;
  color: #205295;
}
.brand-desc {
  margin: 16px 0 0;
  max-width: 250px;
  font-size: 16px;
  line-height: 1.5;
  color: #4b5563;
}

.footer-heading {
  font-size: 18px;
  font-weight: 500;
  color: #0f172a;
  margin-bottom: 20px;
}
.footer-link {
  display: block;
  width: fit-content;
  margin-bottom: 12px;
  font-size: 16px;
  color: #4b5563 !important;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;
  font-weight: 500 !important;
}
.footer-link:hover {
  color: #205295 !important;
}

.footer-bottom {
  margin-top: 32px;
  padding: 32px 0;
  border-top: 1px solid #e5e7eb;
  text-align: center;
  font-size: 16px;
  color: #4b5563;
}
.sep {
  margin: 0 4px;
  color: #9ca3af;
}

@media (max-width: 959px) {
  .footer-wrap {
    padding-top: 36px;
  }
  .footer-heading {
    margin-top: 8px;
    margin-bottom: 12px;
  }
  .footer-bottom {
    font-size: 14px;
  }
}
</style>